import { CoreIcon } from '../core-icon';
import settingFillSVG from '../../assets/icons/setting-fill.svg';
import type { IconProps } from '../core-icon';

export const SettingFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={settingFillSVG} {...props} />;
};
